import { LitElement, css, html } from "lit";
import { customElement } from "lit/decorators.js";

@customElement("bp-text-greek")
export class TextGreek extends LitElement {
  static styles = css`
    :host {
      font-family: var(--font-greek);
      display: inline-block;
      font-weight: normal;
    }
  `;

  render() {
    return html` <slot></slot> `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "bp-text-greek": TextGreek;
  }
}
